export default __webpack_public_path__ + "static/media/lab-test_1_30.d0f63931.png";